<span aria-hidden="true" class="mx-4 text-white hover:text-white">|</span>
